import { StorageUtil } from '../../../../shared/utils/storage';
import { getCurrentToken } from '../../../../shared/utils/token';
import { LEAD_FINDER_EXTENSION_BANNER_DISMISSED_TOKEN_KEY } from './constants';

// Same-tab notification that the banner should hide right away. The native
// `storage` event only fires in OTHER tabs, so we dispatch this on the window
// to let any mounted banner instance react within the current tab.
export const LEAD_FINDER_EXTENSION_BANNER_DISMISSED_EVENT =
  'lead-finder-extension-banner-dismissed';

// True once the user dismissed (X) or opened the install wizard during the
// CURRENT login session. Keyed on the active auth token, so a fresh login
// (which mints a new token) shows the banner again. "No token" is treated as
// dismissed so it never flashes for a logged-out state.
export const isLeadFinderExtensionBannerDismissed = (): boolean => {
  const token = getCurrentToken();
  if (!token) {
    return true;
  }
  return (
    StorageUtil.getItem(LEAD_FINDER_EXTENSION_BANNER_DISMISSED_TOKEN_KEY) ===
    token
  );
};

// Persist dismissal against the current login token and notify any mounted
// banner instance to hide immediately. Called from every place that opens the
// install wizard (banner CTA, Lead Finder empty state, header menu) so the
// banner behaves consistently no matter how the wizard was launched.
export const dismissLeadFinderExtensionBanner = (): void => {
  const token = getCurrentToken();
  if (token) {
    StorageUtil.setItem(LEAD_FINDER_EXTENSION_BANNER_DISMISSED_TOKEN_KEY, token);
  }
  window.dispatchEvent(new Event(LEAD_FINDER_EXTENSION_BANNER_DISMISSED_EVENT));
};
